import 'magnific-popup';

/**
 * Handle Modal
 */
const handleModal = () => {
	const $modal = $('.js-modal');

	$modal.magnificPopup({
		type: 'inline',
		preloader: false
	});
}

handleModal();

/**
 * Close Modal
 */
const closeModal = () => {
	const $closeModalTrigger = $('.modal__close');

	$closeModalTrigger.on('click', function(event) {
		$.magnificPopup.close();

		event.preventDefault();
	});
}

closeModal();
